import React, { Component } from 'react';
import _ from 'lodash'
export default function({bankAccount}){
    return (<div  class="jumbotron mt-4">
        <h1>Bank Info</h1>
        {_.map(bankAccount, (value, key)=>{
            return <p>{key}:  <strong>{value}</strong> </p>
        })}
    </div>)
}